import RestApiModel from "@/api/Model/RestApiModel";
import api from '../index';

class SectionClassificationType extends RestApiModel {
  static getResourceEndpoint() {
    return '/facility-section-classification-types';
  }
}

export default SectionClassificationType;
